import { defineStore } from "pinia";

export const useEvaluationSkillStore = defineStore('evaluationSkill', {
    state: () => ({
        evaluationSkill: {},
        evaluationSkills: [],
    }),
    actions: {
        setEvaluationSkill(evaluationSkill) {
            this.evaluationSkill = evaluationSkill
        },
        setEvaluationSkills(evaluationSkills) {
            this.evaluationSkills = evaluationSkills
        },
        addEvaluationSkill(evaluationSkill) {
            this.evaluationSkills.unshift(evaluationSkill)
        },
        updateEvaluationSkill(evaluationSkill) {
            let index = this.evaluationSkills.findIndex(cl => cl.id === evaluationSkill.id)
            this.evaluationSkills.splice(index, 1, evaluationSkill)
        },
        deleteEvaluationSkill(evaluationSkill) {
            let index = this.evaluationSkills.findIndex(cl => cl.id === evaluationSkill.id)
            this.evaluationSkills.splice(index, 1)
        },
    },
});